import { InfoPageModel } from "api"
import { Dispatch, SetStateAction } from "react"
import TextsPage from "./TextsPage"

type termsProps = {
  data: InfoPageModel
  setRefList: Dispatch<SetStateAction<any[]>>
}

const TermsPage = ({ data, setRefList }: termsProps) => {
  return (
    <TextsPage title={data?.title} text={data?.body} setRefList={setRefList} />
  )
}

export default TermsPage
